import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { TopBar } from "@/components/TopBar";
import { verseOfTheDay } from "@/lib/scripture";
import { ArrowLeft, Printer, Cross } from "lucide-react";

const SUBJECTS = ["English", "Math", "Science", "Bible", "Social Studies"];
const PERIODS = [["Q1", "Quarter 1"], ["Q2", "Quarter 2"], ["Q3", "Quarter 3"], ["Q4", "Quarter 4"]];

export default function ReportCard() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [sid, setSid] = useState("");
  const [data, setData] = useState(null);
  const verse = verseOfTheDay();

  useEffect(() => {
    api.get("/students").then((r) => { setStudents(r.data); if (r.data[0]) setSid(r.data[0].id); });
  }, []);
  useEffect(() => { if (sid) api.get(`/report-card/${sid}`).then((r) => setData(r.data)); }, [sid]);

  return (
    <div>
      <div className="print:hidden"><TopBar subtitle="Report Card" /></div>
      <main className="max-w-4xl mx-auto px-6 md:px-8 py-10">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8 print:hidden">
          <button onClick={() => navigate("/parent")} className="flex items-center gap-2 text-sm text-[#6B7280] hover:text-[#3D405B]"><ArrowLeft size={16} /> Back</button>
          <div className="flex items-center gap-3">
            <select data-testid="reportcard-student" value={sid} onChange={(e) => setSid(e.target.value)}
              className="rounded-full border border-[#EAE6DF] bg-white px-5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#E07A5F]">
              {students.map((s) => <option key={s.id} value={s.id}>{s.first_name}</option>)}
            </select>
            <button data-testid="print-btn" onClick={() => window.print()} className="flex items-center gap-2 rounded-full bg-[#E07A5F] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#c96851] transition-colors">
              <Printer size={16} /> Print / Save PDF
            </button>
          </div>
        </div>

        {data && (
          <div data-testid="report-card" className="rounded-2xl bg-white border border-[#EAE6DF] p-8 md:p-12 print:border-0 print:shadow-none">
            <div className="text-center border-b border-[#EAE6DF] pb-6">
              <div className="flex items-center justify-center gap-2 text-[#E07A5F]"><Cross size={18} /><span className="font-head font-bold text-lg">Rising Force Academy</span></div>
              <h1 className="font-head text-3xl font-bold text-[#3D405B] mt-3">Report Card</h1>
              <p className="text-[#6B7280] mt-1">{data.student.first_name} {data.student.last_name} · Grade {data.student.grade_level}</p>
              <p className="text-xs text-[#6B7280] mt-1 stat">School Year 2025–2026</p>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 mt-8">
              {PERIODS.map(([key, label]) => (
                <div key={key}>
                  <p className="font-head font-semibold text-[#3D405B] mb-2">{label}</p>
                  <table className="w-full text-sm">
                    <tbody>
                      {SUBJECTS.map((subj) => {
                        const row = data.periods[key].subjects[subj];
                        return (
                          <tr key={subj} className="border-b border-[#F2EFE9]">
                            <td className="py-1.5 text-[#6B7280]">{subj}</td>
                            <td className="py-1.5 text-right stat text-[#3D405B]">{row ? `${row.average}%` : "—"}</td>
                            <td className="py-1.5 text-right w-8 font-semibold text-[#3D405B]">{row ? row.letter : ""}</td>
                          </tr>
                        );
                      })}
                      <tr><td className="pt-2 font-semibold text-[#3D405B]">GPA</td><td colSpan={2} className="pt-2 text-right stat font-semibold text-[#81B29A]">{data.periods[key].gpa != null ? `${data.periods[key].gpa}%` : "—"}</td></tr>
                    </tbody>
                  </table>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-xl bg-[#F2EFE9] p-5">
              <p className="font-head font-semibold text-[#3D405B] mb-2">Final Averages</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm">
                {SUBJECTS.map((subj) => {
                  const row = data.final.subjects[subj];
                  return <div key={subj} className="flex justify-between"><span className="text-[#6B7280]">{subj}</span><span className="stat text-[#3D405B]">{row ? `${row.average}% (${row.letter})` : "—"}</span></div>;
                })}
              </div>
              <div className="flex justify-between mt-3 pt-3 border-t border-[#EAE6DF]"><span className="font-semibold text-[#3D405B]">Final GPA</span><span className="stat font-bold text-[#81B29A]">{data.final.gpa != null ? `${data.final.gpa}%` : "—"}</span></div>
            </div>

            <p className="text-center text-sm italic text-[#6B7280] mt-8 flex items-center justify-center gap-2"><Cross size={13} /> "{verse.text}" — {verse.ref}</p>
          </div>
        )}
      </main>
    </div>
  );
}
